import cronstrue from "cronstrue";

const INVALID_CRON_EXPRESSION = "Error: The cron expression is invalid.";

export const renderExpression = (
  expression,
  dayOrWeekInputValid,
  isFrequencyFieldsInValid
) => {
  if (!isFrequencyFieldsInValid) {
    if (expression) {
      if (dayOrWeekInputValid) {
        try {
          return cronstrue.toString(expression);
        } catch (error) {
          console.log({ error });
          return INVALID_CRON_EXPRESSION;
        }
      } else return "Error: Day and week cannot be specified together.";
    } else return INVALID_CRON_EXPRESSION;
  } else return "Please enter a valid cron expression"
};
